import MiniFavoritePresenter from "../components/mini-favorite/presenter/mini-favorite.js";

const triggerElement = document.querySelector(`.header-favorite`);

if (triggerElement) {
  const miniFavoriteComponent = new MiniFavoritePresenter(triggerElement);
  miniFavoriteComponent.init();
}
